<template>
	<div>
		<img v-show="this.$i18n.locale == 'zh'" src="../../../public/pic/product/welcome/D.png" style="width: 100%;height: 600px;"/>
		<img v-show="this.$i18n.locale == 'en'" src="../../../public/pic/product/welcome/D1.png" style="width: 100%;height: 600px;"/>
		<br /><br />
		<div style="width: 1000px;margin: auto;">
			<p style="font-size: 40px;font-weight: bold;">
			{{ $t('lang.Receptionist')}}{{ $t('lang.Robot')}}
		</p>
		
			<img v-show="this.$i18n.locale == 'zh'" src="../../../public/pic/product/welcome/Ua.png" />
			<img v-show="this.$i18n.locale == 'en'" src="../../../public/pic/product/welcome/Ua1.png" />
			
			<hr />
			<p style="font-size: 40px;font-weight: bold;">{{ $t('lang.Video_introduction')}}</p>
			
			<video width="100%" controls>
				<source src="../../../public/pic/product/welcome/YBEN2.mp4" type="video/mp4">
				您的浏览器不支持 video 标签。
			</video>
		
			<br /><br /><br /><br /><br /><br />
			<img v-show="this.$i18n.locale == 'zh'" src="../../../public/pic/product/welcome/1.png" />
			<br /><br /><br /><br /><br /><br />
			<img v-show="this.$i18n.locale == 'zh'" src="../../../public/pic/product/welcome/3.png" />
			<br /><br /><br /><br /><br /><br />
			<img v-show="this.$i18n.locale == 'zh'" src="../../../public/pic/product/welcome/4.png" />
			<br /><br /><br /><br /><br /><br />
			<img v-show="this.$i18n.locale == 'zh'" src="../../../public/pic/product/welcome/5.png" />
			<br /><br /><br /><br /><br /><br />
			<img v-show="this.$i18n.locale == 'zh'" src="../../../public/pic/product/welcome/6.png" />
			<br /><br /><br /><br /><br /><br />
			<img v-show="this.$i18n.locale == 'zh'" src="../../../public/pic/product/welcome/7.png" />
			<br /><br /><br /><br /><br /><br />
			<img v-show="this.$i18n.locale == 'zh'" src="../../../public/pic/product/welcome/8.png" />
			<br /><br /><br /><br /><br /><br />
			<img v-show="this.$i18n.locale == 'zh'" src="../../../public/pic/product/welcome/9.png" />
			<br /><br /><br /><br /><br /><br />
			<img v-show="this.$i18n.locale == 'zh'" src="../../../public/pic/product/welcome/10.png" />
			<br /><br /><br /><br /><br /><br />
			<img v-show="this.$i18n.locale == 'zh'" src="../../../public/pic/product/welcome/11.png" />
			<br /><br /><br /><br /><br /><br />
			<img v-show="this.$i18n.locale == 'zh'" src="../../../public/pic/product/welcome/12.png" />
			<br /><br /><br /><br /><br /><br />
			<img v-show="this.$i18n.locale == 'zh'" src="../../../public/pic/product/welcome/13.png" />
			<br /><br /><br /><br /><br /><br />
		
			<img v-show="this.$i18n.locale == 'zh'" src="../../../public/pic/product/welcome/16.png" />
			

			<p style="font-size: 40px;font-weight: bold;">{{ $t('lang.welcome1')}}</p>
			
			<table border="5" style="border-collapse: collapse; width:100%;">
				<tr>
					<td class="black" style="width: 200px;">{{ $t('lang.welcome2')}}</td>
					<td class="black">{{ $t('lang.welcome3')}}</td>
				</tr>
				<tr>
					<td class="black " style="width: 200px;">{{ $t('lang.welcome4')}}</td>
					<td class="black ">{{ $t('lang.welcome5')}}</td>
				</tr>
				<tr>
					<td class="black " style="width: 200px;">{{ $t('lang.welcome6')}}</td>
					<td class="black ">{{ $t('lang.welcome7')}}</td>
				</tr>
				<tr>
					<td class="black" style="width: 200px;">{{ $t('lang.welcome8')}}</td>
					<td class="black">{{ $t('lang.welcome9')}}</td>
				</tr>
				<tr>
					<td class="black" style="width: 200px;">{{ $t('lang.welcome10')}}</td>
					<td class="black">{{ $t('lang.welcome11')}}</td>
				</tr>
				<tr>
					<td class="black" style="width: 200px;">{{ $t('lang.welcome12')}}</td>
					<td class="black">{{ $t('lang.welcome13')}}</td>
				</tr>
				<tr>
					<td class="black" style="width: 200px;">{{ $t('lang.welcome4')}}</td>
					<td class="black">{{ $t('lang.welcome15')}}</td>
				</tr>
				<tr>
					<td class="black" style="width: 200px;">{{ $t('lang.welcome6')}}</td>
					<td class="black">{{ $t('lang.welcome7')}}</td>
				</tr>
				<tr>
					<td class="black" style="width: 200px;">{{ $t('lang.welcome18')}}</td>
					<td class="black">{{ $t('lang.welcome19')}}</td>
				</tr>
				<tr>
					<td class="black" style="width: 200px;">{{ $t('lang.welcome20')}}</td>
					<td class="black">{{ $t('lang.welcome21')}}</td>
				</tr>
				<tr>
					<td class="black" style="width: 200px;">{{ $t('lang.welcome22')}}</td>
					<td class="black">{{ $t('lang.welcome23')}}</td>
				</tr>
			</table>
			
			<hr />
			<p style="font-size: 40px;font-weight: bold;">{{ $t('lang.uvc_p2')}}</p>
			
			<el-row>
				<el-col :span="12"><img src="../../../public/pic/product/welcome/yinbingC.png" /></el-col>
				<el-col :span="12"><img style="margin-top: 20px;" src="../../../public/pic/product/welcome/yinbingD.png" /></el-col>
			</el-row>
			
			
			<hr />
		</div>
	</div>
</template>

<script>
export default {
	head(){
		return {
			title : '迎宾机器人_深圳全智能机器人科技有限公司。 waiter robot  _Shenzhen all intelligent robot technology Co., Ltd',
			keywords : '迎宾机器人,仿真机器人,人形机器人,讲解机器人,导购机器人, 商务机器人,智能商业迎宾机器人，智能迎宾机器人报价 。welcoming robot,humanoid robot,anthropomorphic robot,broadcasting robot, Shopping guide robot,business robot,Intelligent business welcome robot,Intelligent welcoming robot quote',
			description : '深圳全智能机器人科技有限公司研发生产的迎宾机器人，1比1仿真人设计，内置仿真骨骼，身体皮肤清晰可见,手感光滑细腻。礼貌迎宾+自由讲解+人机交互+自定义内容。支持二次开发，提供SDK接口。全智能（TPE）仿真迎宾讲解机器人，可自主深入学习。The welcoming robot developed and produced by Shenzhen all intelligent robot technology Co., Ltd. is 1:1 bionic real person design, with built-in simulation skeleton, the body skin is clearly visible, and the hand feeling is smooth and delicate. Polite welcome + FREE explanation + human-computer interaction + custom content. it support secondary development, provide SDK web interfaces.The fully intelligent (TPE) simulation robot can learn deeply and autonomously',
		};
	},
}
</script>

<style scoped>
	img{
		width: 100%;
	}
	p{
		color: white;
	}
	.black{
		color: white;
		height:50px;
		font-size: 20px;
		font-weight: bold;
		padding-left:2em;
	}
</style>
